export default "__VITE_ASSET__CnqZqEui__"